import { useLanguage } from '@/i18n/language-context';
import { languagePersistenceCopy } from '@/i18n/language-persistence-copy';
import { Button } from './ui/button';
import './language-sync-notice.css';

/** A recoverable save failure stays inline and never interrupts navigation. */
export function LanguageSyncNotice(): JSX.Element | null {
  const { locale, persistence } = useLanguage();
  if (persistence?.state !== 'error') return null;
  const copy = languagePersistenceCopy[locale];
  return (
    <aside className="language-sync-notice" role="alert">
      <p>{copy.failed}</p>
      <Button variant="ghost" size="sm" onClick={persistence.retry}>
        {copy.retry}
      </Button>
    </aside>
  );
}
